import React from 'react';
import AsyncSelect from 'react-select/async';
import axios from 'axios';

const DynamicFormBuilder = ({ fields, values, onChange }) => {
  const handleFieldChange = (fieldName, value) => {
    onChange({
      ...values,
      [fieldName]: value
    });
  };

  const loadAsyncOptions = async (dataSource, inputValue) => {
    try {
      const response = await axios.get(dataSource, {
        params: { search: inputValue, limit: 50 },
        withCredentials: true
      });
      return response.data.map(item => ({
        value: item.id,
        label: item.name || item.companyName || `${item.firstName || ''} ${item.lastName || ''}`.trim(),
        data: item
      }));
    } catch (error) {
      console.error('Error loading options:', error);
      return [];
    }
  };

  const renderField = (field) => {
    const value = values[field.name] || field.default || '';

    switch (field.type) {
      case 'text':
      case 'number':
      case 'date':
        return (
          <input
            type={field.type}
            value={value}
            onChange={(e) => handleFieldChange(field.name, e.target.value)}
            placeholder={field.placeholder}
            required={field.required}
          />
        );

      case 'textarea':
        return (
          <textarea
            value={value}
            onChange={(e) => handleFieldChange(field.name, e.target.value)}
            placeholder={field.placeholder}
            required={field.required}
            rows="4"
          />
        );

      case 'select':
        return (
          <select
            value={value}
            onChange={(e) => handleFieldChange(field.name, e.target.value)}
            required={field.required}
          >
            <option value="">Select...</option>
            {field.options.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        );

      case 'async-select':
        return (
          <AsyncSelect
            cacheOptions
            loadOptions={(inputValue) => loadAsyncOptions(field.dataSource, inputValue)}
            defaultOptions
            value={value}
            onChange={(option) => handleFieldChange(field.name, option)}
            placeholder={field.placeholder || 'Search...'}
            isClearable
          />
        );

      case 'multiselect':
        if (field.dataSource) {
          return (
            <AsyncSelect
              isMulti
              cacheOptions
              loadOptions={(inputValue) => loadAsyncOptions(field.dataSource, inputValue)}
              defaultOptions
              value={value}
              onChange={(options) => handleFieldChange(field.name, options)}
              placeholder={field.placeholder || 'Select multiple...'}
            />
          );
        } else {
          return (
            <select
              multiple
              value={value}
              onChange={(e) => {
                const selected = Array.from(e.target.selectedOptions, option => option.value);
                handleFieldChange(field.name, selected);
              }}
              required={field.required}
            >
              {field.options.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          );
        }

      case 'checkbox':
        return (
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={value || false}
              onChange={(e) => handleFieldChange(field.name, e.target.checked)}
            />
            <span>{field.label}</span>
          </label>
        );

      default:
        return <input type="text" value={value} onChange={(e) => handleFieldChange(field.name, e.target.value)} />;
    }
  };

  return (
    <div className="dynamic-form-builder">
      {fields.map(field => (
        <div key={field.name} className="config-field">
          {field.type !== 'checkbox' && (
            <label>
              {field.label}
              {field.required && <span className="required">*</span>}
            </label>
          )}
          {renderField(field)}
          {field.helpText && <small className="help-text">{field.helpText}</small>}
        </div>
      ))}
    </div>
  );
};

export default DynamicFormBuilder;

